/**
 * aswbe reservation eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * GMOP情報<br/> 支払方法がインターネットバンキング、コンビニエンスストア支払い<br/> のいずれかである場合に設定する。
 */
export interface PaymentRequestGeneralPaymentMethod {
  /**
   * 支払方法<br/> 利用する支払方法を指定する。<br/> 設定値ごとの支払方法は以下とする。<br/> internetBanking:インターネットバンキング<br/> convenienceStore：コンビニエンスストア支払い
   */
  paymentMethod: PaymentRequestGeneralPaymentMethod.PaymentMethodEnum;
  /**
   * 銀行コード<br/> 支払方法がインターネットバンキングである場合に設定を必須とする。
   */
  bankCode?: string;
}
export namespace PaymentRequestGeneralPaymentMethod {
  export type PaymentMethodEnum = 'internetBanking' | 'convenienceStore' | 'payEasy';
  export const PaymentMethodEnum = {
    InternetBanking: 'internetBanking' as PaymentMethodEnum,
    ConvenienceStore: 'convenienceStore' as PaymentMethodEnum,
    PayEasy: 'payEasy' as PaymentMethodEnum,
  };
}
